import { render, staticRenderFns } from "./Cotiza.vue?vue&type=template&id=5edbef90&scoped=true&lang=pug"
import script from "./Cotiza.vue?vue&type=script&lang=js"
export * from "./Cotiza.vue?vue&type=script&lang=js"
import style0 from "./Cotiza.vue?vue&type=style&index=0&id=5edbef90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edbef90",
  null
  
)

export default component.exports